import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { SalesOrderHeader } from "../../../../core/models/orders/saleOrderHeader";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { ShipToAddressComponent } from "../../../../shared/components/ship-to-address/ship-to-address.component";
import { GetVendorSearchResponseDto } from "../../../../core/models/vendor/getVendorSearchResponseDto";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { Address } from "../../../../core/models/shared/address";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { GetAllVendorsDto } from "../../../../core/models/vendor/getAllVendors";
import { PurchaseOrderHeader } from "../../../../core/models/samplePO/details/purchaseOrderHeader";
import { SalesOrderLineFormDto } from "../../../../core/models/orders/salesOrderLineFormDto";
// import { PurchaseOrderHeader } from "../../../../core/models/samplePO/details/samplePOSummaryDto";
// import { PurchaseOrderHeader } from "../../../../core/models/samplePO/details/samplePOSummaryDto";

@UntilDestroy()
@Component({
  selector: "jni-order-line-ship-to",
  templateUrl: "./order-line-ship-to.component.html",
  styleUrls: ["./order-line-ship-to.component.scss"],
  imports: [ReactiveFormsModule, ShipToAddressComponent],
})
export class OrderLineShipToComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Input() countryRegionList: AddressCountryRegion[] = [];
  @Input() vendroAddressBookObject!: GetAllVendorsDto;
  @Input() addressObject!: Address;
  @Input() headerObject!: SalesOrderHeader | PurchaseOrderHeader;
  @Input() customerList: Address[] = [];
  @Input() formErrors!: Record<string, string>;
  //@Input() customerBillToObject!: any;
  @Input() showAddress = false;
  @Input() clientShipToAddressDisabled = false;
  @Input() vendorNameShipToAddressDisabled = false;
  @Output() validationErrorEvent = new EventEmitter();
  @Input() isEditFromCdi = false;
  @Input() fromAddressAssignment = false;
  @Input() defaultOneTime = "One Time";
  @Input() orderType = "";
  @Input() isShipToAddresssFromOrderLines = false;
  @Input() lineStatusD365 = "";
  @Input() collapseStatus = false;

  currencyObject?: ExchangeRatesDto;
  currencyConversion?: ExchangeRatesDto;

  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  showForeignCurrency = false;
  shipToAddress = false;
  vendorAccountAndBook = false;
  firmOneCheckBox = false;

  vendorList: GetVendorSearchResponseDto[] = [];
  clientLists: ClientSearchList[] = [];
  addressBookList: Address[] = [];
  shiftToAddressList!: Address[];
  //vendorAccountSearchList: any;

  shiftToAddressField = "";
  selectedAccountNumber = "";
  vendorAccountSeletion = "";
  addressBookName = "";
  isAddressValidationButton = true;

  showSmallLoader = false;
  countryRegionSelectedId = "";

  //getFilteredZipCode: any[] = [];
  //getZipCode: any[] = [];
  //cityList: City[] = [];
  //stateSelectedId = '';
  //stateList: AddressState[] = [];
  //districtList: District[] = [];
  //countyList: AddressCounty[] = [];
  addressValidationStatus = true;
  public searchVendor$ = new Subject<string>();

  @ViewChild("shipTo", { static: false })
  shipTo!: ShipToAddressComponent;

  @Output() isMelissaValidationIgnore = new EventEmitter<boolean>();
  @Output() isMelissaAddressValidated = new EventEmitter<boolean>();

  constructor(private _samplepoListingService: SamplepoListingService) {}

  ngOnInit(): void {
    this.searchVendorName();

    this.parent.valueChanges.subscribe(data => {
      this.addressValidation(data);
    });
  }

  clearShipToAddressForm() {
    this.shiftToAddressField = "";
    //this.countryRegionSelectedId = '';
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
    this.shipToAddress = false;
    this.vendorAccountAndBook = false;
    this.showAddress = true;
    this.shipTo.clearShipToAddressForm();
  }

  addressValidation(data: SalesOrderLineFormDto) {
    const addressObj = data.shipTo;
    if (
      addressObj.countryRegionIdD365 != "" &&
      addressObj.countryRegionIdD365 != null &&
      addressObj.cityD365 != "" &&
      addressObj.cityD365 != null &&
      addressObj.stateD365 != "" &&
      addressObj.stateD365 != null
    ) {
      this.isAddressValidationButton = false;
      this.parent
        .get(["shipTo", "addressD365"])
        ?.setValidators(Validators.required);
    } else {
      this.isAddressValidationButton = true;
    }
  }

  showAddressFieldLineSelection(addressSelectionName: string) {
    if (addressSelectionName.toLowerCase() === "to vendor") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
    } else if (
      addressSelectionName.toLowerCase() === "client address book" ||
      addressSelectionName.toLowerCase() == "address book" ||
      addressSelectionName.toLowerCase() == "to address book"
    ) {
      this.shipToAddress = true;
      this.vendorAccountAndBook = false;
    }
  }

  onDeliveryAddressChange(event: string) {
    this.shipTo.showName = true;
    if (
      event === "Client Address Book" ||
      event === "Client address book" ||
      event == "Address book" ||
      event == "To address book"
    ) {
      this.shipTo.showName = false;
      this.shipToAddress = true;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.patchAddressOfVendorAddressBook();
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
    } else if (event === "To Vendor" || event == "To vendor") {
      this.shipTo.showName = false;
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
    } else if (
      event === "To Header Ship To" ||
      event == "To header ship to" ||
      event == "To header ship-to"
    ) {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      if (this.addressObject) {
        this.patchFormInHeaderToShip(this.addressObject);
      }
      if (this.headerObject) {
        this.patchFormInHeaderToShipAddress(this.headerObject);
      }
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.parent.get(["shipTo", "addressD365"])?.disable();
      this.disableDeliveryName();
    } else {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = true;
      this.showValidateAddress = true;
      this.showAddress = false;
      this.applyValidationOnAddress();
      if (event !== "One time") {
        this.clearShifToForm();
      }
      if (event === "One time") {
        this.clearValidationOnAddress();
      }
    }
    this.enableCountryField(event);
  }

  patchValueInCustomerShipToName(descriptionD365: string) {
    this.shipTo.shiftToAddressField = descriptionD365;
  }

  patchFormInHeaderToShip(address: Address) {
    this.parent.patchValue({
      shipTo: {
        countryRegionIdD365: address.countryRegionIdD365,
        zipCodeD365: address.zipCodeD365,
        streetD365: address.streetD365,
        cityD365: address.cityD365,
        stateD365: address.stateD365,
        countyD365: address.countyD365,
        streetNumberD365: address.streetNumberD365,
        buildingComplimentD365: address.buildingComplimentD365,
        apartment_RUD365:
          address.apartment_RUD365 === null ? "" : address.apartment_RUD365,
        postBoxD365: address.postBoxD365,
        districtNameD365: address.districtNameD365,
        addressLocationNumber: parseInt(address.locationNumberD365 ?? ""),
        addressD365: address?.addressD365?.replace("<br/>", "\n"),
      },
    });

    // ToDO the code if address lines needed to show
    //  const countryRegion  = this.parent.get([
    //   "shipTo",
    //   "countryRegionIdD365",
    // ])?.value;

    //  if(countryRegion !== 'USA'){
    //    this.shipTo.salesOrderEditCase = true;
    //    this.shipTo.onCountryRegionSelection(countryRegion ?? '') ;
    //    this.shipTo.showAddressLinesFields = false; // To Show Address Lines1,2,3
    // }
  }

  patchFormInHeaderToShipAddress(
    header: SalesOrderHeader | PurchaseOrderHeader
  ) {
    this.parent.patchValue({
      shipTo: {
        attentionInformationD365: header.attentionInformationD365,
        locationD365: header.locationD365 ?? "",
        rSMJNIShipToEmailD365:
          this.orderType == "inventory-purchase"
            ? (header.shipToEmail ?? "")
            : (header.rsmjniShipToEmail ?? ""),
        deliveryNameD365: header.deliveryNameD365,
      },
    });
    this.shipTo.showName = true;
    this.disableDeliveryName();
  }

  // enableDeliveryName() {
  //   this.parent.get(['shipTo', 'deliveryNameD365'])?.enable();
  // }

  disableDeliveryName() {
    this.parent.get(["shipTo", "deliveryNameD365"])?.disable();
  }

  patchValueInMultiShipToAndTbd(event: string) {
    this.patchFormDeliveryAddress("", event);
  }

  patchFormDeliveryAddress(
    addressSelectionName: string,
    headerAddressSelection: string
  ) {
    if (addressSelectionName) {
      this.parent.patchValue({
        shipTo: {
          addressSelectionName: addressSelectionName,
        },
      });
    }
    if (addressSelectionName?.toLowerCase()?.includes("header")) {
      this.disabledAttentionandLocationField();
    }
    if (
      headerAddressSelection &&
      (headerAddressSelection?.toLowerCase()?.includes("multi") ||
        headerAddressSelection?.toLowerCase()?.includes("drop") ||
        headerAddressSelection?.toLowerCase()?.includes("tbd"))
    ) {
      const headerAddressSelectionName = headerAddressSelection;
      this.parent.patchValue({
        shipTo: {
          addressD365: headerAddressSelectionName,
        },
      });
    }
  }

  enableCountryField(event: string) {
    if (event === "One time" || event === "One time blank") {
      this.parent.get(["shipTo", "countryRegionIdD365"])?.enable();
      this.parent.get(["shipTo", "streetD365"])?.enable();
    } else {
      this.parent.get(["shipTo", "countryRegionIdD365"])?.disable();
      this.parent.get(["shipTo", "streetD365"])?.disable();
    }
  }

  disabledAttentionandLocationField() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.disable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.parent.get(["shipTo", "locationD365"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
  }

  enableAttentionandLocationField() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.enable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.enable();
    this.parent.get(["shipTo", "locationD365"])?.enable();
  }

  applyValidationOnAddress() {
    this.parent
      .get(["shipTo", "addressD365"])
      ?.setValidators(Validators.required);
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
  }

  hiddenAddressFields() {
    this.showDistrict = false;
    this.showPostBox = false;
    this.showCity = false;
    this.showCounty = false;
    this.showState = false;
    this.showStreetNumber = false;
    this.showbuildingComplement = false;
    this.showAddressBook = false;
    this.showAppartment = false;
  }

  patchAddressOfVendorAddressBook() {
    this.showSmallLoader = true;
    if (
      this.vendroAddressBookObject?.partyNumber != undefined ||
      this.vendroAddressBookObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.vendroAddressBookObject?.partyNumber,
          this.vendroAddressBookObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.shiftToAddressList = res.data;
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  clearValidationOnAddress() {
    this.parent.get(["shipTo", "addressD365"])?.clearValidators();
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
  }

  // onshipToAddressFilter(drop: any) {
  //   drop.open();
  // }

  // onShitToAddressSeletion(event: any, shipAddressToggle: any) {
  //   shipAddressToggle.close();
  //   if (event.descriptionD365 != '') {
  //     this.shiftToAddressField = event.descriptionD365;
  //   }
  //   this.patchFormInShipToAddressField(event);
  //   if (this.headerObject) {
  //     this.patchFormInHeaderToShipAddress(this.headerObject);
  //   }
  // }

  // patchFormInShipToAddressField(address: Address) {
  //   this.parent.patchValue({
  //     shipTo: {
  //       countryRegionIdD365: address.countryRegionIdD365,
  //       zipCodeD365: address.zipCodeD365,
  //       streetD365: address.streetD365,
  //       cityD365: address.cityD365,
  //       stateD365: address.stateD365,
  //       countyD365: address.countyD365,
  //       streetNumberD365: address.streetNumberD365,
  //       buildingComplimentD365: address.buildingComplimentD365,
  //       apartment_RUD365:
  //         address.apartment_RUD365 === null ? '' : address.apartment_RUD365,
  //       postBoxD365: address.postBoxD365,
  //       districtNameD365: address.districtNameD365,
  //       addressLocationNumber:
  //         address.locationNumberD365 === null
  //           ? 0
  //           : parseInt(address.locationNumberD365 || '0'),
  //       addressD365: address?.addressD365?.replace('<br/>', '\n')
  //     }
  //   });
  // }

  getVendorByName(accountNumberOrName: string) {
    if (accountNumberOrName !== "") {
      this._samplepoListingService
        .getVendorByNameAndAccountNumberFilter(accountNumberOrName)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.data) {
              this.getVendorAddress(res?.data[0]?.partyNumber ?? "");
              this.shipTo.vendorAccountSeletion = res?.data[0]?.vendorName;
              this.shipTo.addressBookName = res?.data[0]?.vendorName;
            }
          },
        });
    }
  }

  getVendorAddress(partyNumber: string) {
    this._samplepoListingService
      .getVendorAddressByPartyNumber(partyNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.addressBookList = res.data;
          }
        },
      });
  }

  searchVendorName() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          this.showSmallLoader = true;
          const accountNumberOrName = searchitem;
          this.vendorList = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._samplepoListingService.getVendorByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.vendorList = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // onVendorSearchOpenToggle(mydrop: any) {
  //   mydrop.open();
  // }

  // onVendorAccountSelection(event: any, vendorAccount: any) {
  //   this.clearShifToForm();
  //   this.vendorAccountSeletion = event.vendorName;
  //   const partyNumber = event.partyNumber;
  //   if (
  //     this.vendorAccountSeletion != undefined &&
  //     this.vendorAccountSeletion != ''
  //   ) {
  //     this._samplepoListingService
  //       .getVendorAddressByPartyNumber(partyNumber)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: any) => {
  //           if (res.data != null) {
  //             this.addressBookList = res.data;
  //             this.patchValueInVendorAccount(
  //               event.vendorAccountNumber,
  //               this.vendorAccountSeletion
  //             );
  //             if (this.addressBookList.length === 1) {
  //               this.onVendorAddressBookSelection(this.addressBookList[0], '');
  //             }
  //           }
  //         }
  //       });
  //   }
  //   vendorAccount.close();
  // }

  // patchValueInVendorAccount(vendorAccount: string, vendorName: string) {
  //   this.parent.patchValue({
  //     shipTo: {
  //       shipToVendorAccountD365: vendorAccount,
  //       shipToVendorAccountNameD365: vendorName
  //     }
  //   });
  // }

  clearShifToForm() {
    this.parent.patchValue({
      shipTo: {
        // countryRegionIdD365: '',
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  // onVendorAddressBookSelection(event: any, vendorAddressBookToggle: any) {
  //   this.addressBookName = event.descriptionD365;
  //   this.parent.patchValue({
  //     shipTo: {
  //       countryRegionIdD365: event.countryRegionIdD365,
  //       zipCodeD365: event.zipCodeD365,
  //       streetD365: event.streetD365,
  //       cityD365: event.cityD365,
  //       stateD365: event.stateD365,
  //       countyD365: event.countyD365,
  //       streetNumberD365: event.streetNumberD365,
  //       buildingComplimentD365: event.buildingComplimentD365,
  //       apartment_RUD365:
  //         event.apartment_RUD365 === null ? '' : event.apartment_RUD365,
  //       postBoxD365: event.postBoxD365,
  //       districtNameD365: event.districtNameD365,
  //       addressLocationNumber: parseInt(event.locationNumberD365),
  //       addressD365: event.addressD365?.replace('<br/>', '\n')
  //     }
  //   });
  //   if (vendorAddressBookToggle) {
  //     vendorAddressBookToggle.close();
  //   }
  // }

  // onVendorAddressBookSelect(event: any) {
  //   event.open();
  // }

  // onCountryRegionSelection(countryid: string) {
  //   if (countryid) {
  //     this.parent.get(['shipTo', 'zipCodeD365'])?.enable();
  //     this.parent.get(['shipTo', 'cityD365'])?.enable();
  //     this.parent.get(['shipTo', 'stateD365'])?.enable();
  //   } else {
  //     this.parent.get(['shipTo', 'zipCodeD365'])?.disable();
  //     this.parent.get(['shipTo', 'cityD365'])?.disable();
  //     this.parent.get(['shipTo', 'stateD365'])?.disable();
  //   }

  //   const countryregionid = countryid != null ? countryid : '';
  //   if (countryregionid == '') {
  //     this.cityList != null ? (this.cityList.length = 0) : null;
  //     this.stateList != null ? (this.stateList.length = 0) : null;
  //     this.addressValidationStatus = true;
  //     this.updateValueOnCountrySelection();
  //   } else {
  //     this.updateValueOnCountrySelection();
  //     this.filterAddressFormats(countryregionid);
  //     this.getCountyListData(countryregionid);
  //     this.getStateListData(countryregionid);
  //   }
  // }

  // filterAddressFormats(countryId: string) {
  //   const filteredRegions = this.countryRegionList.filter(
  //     (x) => x.countryRegionD365 == countryId
  //   );
  //   this.getAddressFormats(filteredRegions[0].addressFormatD365);
  // }

  // getAddressFormats(formatId: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getAddressFormatsByFormatId(formatId)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // filterAddressesUsingAddressFormats(description: string | null) {
  //   if (
  //     !description?.toLowerCase().includes('zip') &&
  //     !description?.toLowerCase().includes('postal_code') &&
  //     !description?.toLowerCase().includes('postcode') &&
  //     !description?.toLowerCase().includes('postal code')
  //   ) {
  //     this.showZip = false;
  //   } else {
  //     this.showZip = true;
  //   }
  //   if (!description?.toLowerCase().includes('district')) {
  //     this.showDistrict = false;
  //   } else {
  //     this.showDistrict = true;
  //   }
  //   if (!description?.toLowerCase().includes('city')) {
  //     this.showCity = false;
  //   } else {
  //     this.showCity = true;
  //   }
  //   if (!description?.toLowerCase().includes('county')) {
  //     this.showCounty = false;
  //   } else {
  //     this.showCounty = true;
  //   }
  //   if (
  //     !description?.toLowerCase().includes('state') &&
  //     !description?.toLowerCase().includes('province')
  //   ) {
  //     this.showState = false;
  //   } else {
  //     this.showState = true;
  //   }
  //   if (!description?.toLowerCase().includes('street')) {
  //     this.showStreet = false;
  //   } else {
  //     this.showStreet = true;
  //   }
  //   if (!description?.toLowerCase().includes('number')) {
  //     this.showStreetNumber = false;
  //   } else {
  //     this.showStreetNumber = true;
  //   }
  //   if (
  //     !description?.toLowerCase().includes('complement') &&
  //     !description?.toLowerCase().includes('building')
  //   ) {
  //     this.showbuildingComplement = false;
  //   } else {
  //     this.showbuildingComplement = true;
  //   }
  //   if (!description?.toLowerCase().includes('apartment')) {
  //     this.showAppartment = false;
  //   } else {
  //     this.showAppartment = true;
  //   }
  //   const poBox = description
  //     ?.toLowerCase()
  //     .split(',')
  //     .join(' ')
  //     .split('/')
  //     .join(' ')
  //     .split('_')
  //     .join(' ')
  //     .split(';')
  //     .join(' ')
  //     .split(' ')
  //     .some((x) => x == 'post' || x == 'postbox');
  //   if (!poBox) {
  //     this.showPostBox = false;
  //   } else {
  //     this.showPostBox = true;
  //   }
  // }

  // updateValueOnCountrySelection() {
  //   this.parent.patchValue({
  //     shipTo: {
  //       zipCodeD365: '',
  //       districtNameD365: '',
  //       cityD365: '',
  //       countyD365: '',
  //       stateD365: ''
  //     }
  //   });
  // }

  // getStateListData(id: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getStateList(id)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.stateList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // selectedZipCode(zipCode: any) {
  //   if (!zipCode) {
  //     return;
  //   }
  //   this._addNewClientService
  //     .getPostalCodeByZipCode(zipCode)
  //     .subscribe((res) => {
  //       this.showSmallLoader = true;
  //       if (!res.data) {
  //         this.showSmallLoader = false;
  //         return;
  //       }
  //       this._addNewClientService
  //         .getCityList(res.data.stateId, res.data.countryRegionId)
  //         .pipe(
  //           map((cityResponse) => {
  //             this.cityList = cityResponse.data;

  //             return cityResponse.data.filter(
  //               (city) =>
  //                 city.cityKeyD365?.includes(res?.data?.cityId) &&
  //                 city.countryRegionIdD365 == res?.data?.countryRegionId &&
  //                 city.countyIdD365 == res?.data?.countyId &&
  //                 city.stateIdD365 == res?.data?.stateId
  //             );
  //           })
  //         )
  //         .pipe(untilDestroyed(this))
  //         .subscribe({
  //           next: (response) => {
  //             this.parent.patchValue({
  //               shipTo: {
  //                 countyD365: response[0]?.countyIdD365,
  //                 cityD365: response[0]?.nameD365,
  //                 stateD365: response[0]?.stateIdD365,
  //                 streetD365: res?.data?.street,
  //                 addressLocationNumber: 0
  //               }
  //             });
  //             this.showSmallLoader = false;
  //           },
  //           error: () => {
  //             this.showSmallLoader = false;
  //           }
  //         });
  //     });
  // }

  // searchZipCode: OperatorFunction<string, readonly string[]> = (
  //   text$: Observable<string>
  // ) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     switchMap(async (term: string) =>
  //       term.length < 4
  //         ? []
  //         : (this.getFilteredZipCode = await this.getZipListData(
  //             this.countryRegionSelectedId,
  //             term
  //           ))
  //     )
  //   );

  // async getZipListData(id: string, name: string) {
  //   this.getFilteredZipCode = [];
  //   this.showSmallLoader = true;
  //   const res = await lastValueFrom(
  //     this._addNewClientService.getZipList(id, name).pipe(untilDestroyed(this))
  //   );
  //   this.getZipCode = res.data;
  //   this.showSmallLoader = false;
  //   return this.getZipCode;
  // }

  // onStateSelectionChange(stateid: string) {
  //   this.parent.patchValue({ shipTo: { cityD365: '' } });
  //   this.getCityListData(stateid, this.countryRegionSelectedId);
  // }

  // getCityListData(stateid: string, countryid: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getCityList(stateid, countryid)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.cityList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // async zipCodeSearchFilter(event: any) {
  //   this.selectedZipCode(event.value);
  // }

  // getCountyListData(id: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getCountyList(id)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.countyList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // validateAddress() {
  //   this.showSmallLoader = true;
  //   const address = 'usa ca street 1';
  //   this._addNewClientService
  //     .checkAddressValidation(address)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.showSmallLoader = false;
  //         if (res.data == true) {
  //           this.parent.get(['shipTo', 'addressD365'])?.clearValidators();
  //           this.parent
  //             .get(['shipTo', 'addressD365'])
  //             ?.updateValueAndValidity();
  //           this.addressValidationStatus = false;
  //         }
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // showAddressComponent() {
  //   const deliveryAddress = this.parent.get([
  //     'shipTo',
  //     'addressSelectionName'
  //   ])?.value;
  //   if (deliveryAddress?.toLowerCase().includes('one')) {
  //     this.parent.get(['shipTo', 'addressD365'])?.enable();
  //     //this.showAddress = false;
  //     return true;
  //   } else {
  //     this.parent.get(['shipTo', 'addressD365'])?.disable();
  //     //this.showAddress = true;
  //     return false;
  //   }
  // }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  handleMelissaValidationIgnore(value: boolean) {
    this.isMelissaValidationIgnore.emit(value);
  }

  melissaAddressValidatedEvent(value: boolean) {
    this.isMelissaAddressValidated.emit(value);
  }
}
